"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * REST API Detection Catalog
 * This schema defines the REST API endpoints for the detection catalog
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DetectionMgmtUpdateInputToJSON = exports.DetectionMgmtUpdateInputFromJSONTyped = exports.DetectionMgmtUpdateInputFromJSON = exports.instanceOfDetectionMgmtUpdateInput = void 0;
var runtime_1 = require("../runtime");
var DetconInput_1 = require("./DetconInput");
var DetectionStatus_1 = require("./DetectionStatus");
var DetectionType_1 = require("./DetectionType");
var LogSource_1 = require("./LogSource");
var MitreID_1 = require("./MitreID");
var OptIn_1 = require("./OptIn");
var TagInput_1 = require("./TagInput");
/**
 * Check if a given object implements the DetectionMgmtUpdateInput interface.
 */
function instanceOfDetectionMgmtUpdateInput(value) {
    var isInstance = true;
    isInstance = isInstance && "lastUpdateTime" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "source" in value;
    isInstance = isInstance && "scope" in value;
    isInstance = isInstance && "integrations" in value;
    isInstance = isInstance && "filename" in value;
    isInstance = isInstance && "detectionType" in value;
    return isInstance;
}
exports.instanceOfDetectionMgmtUpdateInput = instanceOfDetectionMgmtUpdateInput;
function DetectionMgmtUpdateInputFromJSON(json) {
    return DetectionMgmtUpdateInputFromJSONTyped(json, false);
}
exports.DetectionMgmtUpdateInputFromJSON = DetectionMgmtUpdateInputFromJSON;
function DetectionMgmtUpdateInputFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'firstAddedTime': !(0, runtime_1.exists)(json, 'firstAddedTime') ? undefined : (json['firstAddedTime'] === null ? null : new Date(json['firstAddedTime'])),
        'lastUpdateTime': (new Date(json['lastUpdateTime'])),
        'status': (0, DetectionStatus_1.DetectionStatusFromJSON)(json['status']),
        'source': json['source'],
        'scope': json['scope'],
        'content': !(0, runtime_1.exists)(json, 'content') ? undefined : json['content'],
        'details': !(0, runtime_1.exists)(json, 'details') ? undefined : json['details'],
        'optIns': !(0, runtime_1.exists)(json, 'optIns') ? undefined : (json['optIns'] === null ? null : json['optIns'].map(OptIn_1.OptInFromJSON)),
        'schema': !(0, runtime_1.exists)(json, 'schema') ? undefined : json['schema'],
        'integrations': (json['integrations'].map(LogSource_1.LogSourceFromJSON)),
        'filename': json['filename'],
        'allDetectionsExtracted': !(0, runtime_1.exists)(json, 'allDetectionsExtracted') ? undefined : json['allDetectionsExtracted'],
        'detectionType': (0, DetectionType_1.DetectionTypeFromJSON)(json['detectionType']),
        'detcons': !(0, runtime_1.exists)(json, 'detcons') ? undefined : (json['detcons'] === null ? null : json['detcons'].map(DetconInput_1.DetconInputFromJSON)),
        'mitreGroups': !(0, runtime_1.exists)(json, 'mitreGroups') ? undefined : (json['mitreGroups'] === null ? null : json['mitreGroups'].map(MitreID_1.MitreIDFromJSON)),
        'mitreSoftware': !(0, runtime_1.exists)(json, 'mitreSoftware') ? undefined : (json['mitreSoftware'] === null ? null : json['mitreSoftware'].map(MitreID_1.MitreIDFromJSON)),
        'mitreTactics': !(0, runtime_1.exists)(json, 'mitreTactics') ? undefined : (json['mitreTactics'] === null ? null : json['mitreTactics'].map(MitreID_1.MitreIDFromJSON)),
        'mitreTechniques': !(0, runtime_1.exists)(json, 'mitreTechniques') ? undefined : (json['mitreTechniques'] === null ? null : json['mitreTechniques'].map(MitreID_1.MitreIDFromJSON)),
        'tags': !(0, runtime_1.exists)(json, 'tags') ? undefined : (json['tags'] === null ? null : json['tags'].map(TagInput_1.TagInputFromJSON)),
    };
}
exports.DetectionMgmtUpdateInputFromJSONTyped = DetectionMgmtUpdateInputFromJSONTyped;
function DetectionMgmtUpdateInputToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'firstAddedTime': value.firstAddedTime === undefined ? undefined : (value.firstAddedTime === null ? null : value.firstAddedTime.toISOString()),
        'lastUpdateTime': (value.lastUpdateTime.toISOString()),
        'status': (0, DetectionStatus_1.DetectionStatusToJSON)(value.status),
        'source': value.source,
        'scope': value.scope,
        'content': value.content,
        'details': value.details,
        'optIns': value.optIns === undefined ? undefined : (value.optIns === null ? null : value.optIns.map(OptIn_1.OptInToJSON)),
        'schema': value.schema,
        'integrations': (value.integrations.map(LogSource_1.LogSourceToJSON)),
        'filename': value.filename,
        'allDetectionsExtracted': value.allDetectionsExtracted,
        'detectionType': (0, DetectionType_1.DetectionTypeToJSON)(value.detectionType),
        'detcons': value.detcons === undefined ? undefined : (value.detcons === null ? null : value.detcons.map(DetconInput_1.DetconInputToJSON)),
        'mitreGroups': value.mitreGroups === undefined ? undefined : (value.mitreGroups === null ? null : value.mitreGroups.map(MitreID_1.MitreIDToJSON)),
        'mitreSoftware': value.mitreSoftware === undefined ? undefined : (value.mitreSoftware === null ? null : value.mitreSoftware.map(MitreID_1.MitreIDToJSON)),
        'mitreTactics': value.mitreTactics === undefined ? undefined : (value.mitreTactics === null ? null : value.mitreTactics.map(MitreID_1.MitreIDToJSON)),
        'mitreTechniques': value.mitreTechniques === undefined ? undefined : (value.mitreTechniques === null ? null : value.mitreTechniques.map(MitreID_1.MitreIDToJSON)),
        'tags': value.tags === undefined ? undefined : (value.tags === null ? null : value.tags.map(TagInput_1.TagInputToJSON)),
    };
}
exports.DetectionMgmtUpdateInputToJSON = DetectionMgmtUpdateInputToJSON;
